import RequestBuilder from 'Resources/RequestBuilder';
import AppService from 'App/legacy/AppService';
import MultiActions from 'Resources/MultiActions';

const archiveTickets = (rb: RequestBuilder, entity: string, selected: number, extraParams?: object) => {
	const properties = [{ name: 'isArchived', value: true }];
	const customerId = AppService.getCustomerId();
	return MultiActions.customer(customerId).updateTicket(selected, properties, rb.build());
};

export default archiveTickets;
